import React from "react";
import * as styles from "./audio.module.css";

const audioData = [
  {
    text: "Hello",
    path: "/assets/audios/check.mp3",
  },
];

export default function Audio() {
  return (
    <div>
      <p>This is just the beginning, will do the rest with ML. lol. maybe</p>
      <table>
        <tr>
          <th>Quote</th>
          <th>Audio</th>
        </tr>
        {audioData.map(value => (
          <tr>
            <td>{value.text}</td>
            <td>
              <audio controls>
                <source src={value.path} type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
            </td>
          </tr>
        ))}
      </table>
    </div>
  );
}
